import { FormControl, InputLabel, Input, Button } from "@mui/material";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { toast } from "react-toastify";
// import OAuth from "../components/OAuth.jsx";

function SignInForm(props) {
  // const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const { setAppState } = props;

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      const auth = getAuth();

      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      if (userCredential.user) {
        setAppState((prevState) => ({
          ...prevState,
          currentUser: userCredential.user,
        }));
      }
    } catch (error) {
      toast.error("Bad User Credentials");
    }
  };
  return (
    <>
      <Typography variant="h3" component="h2">
        Sign in
      </Typography>
      <br />
      <form onSubmit={onSubmit}>
        <div>
          <FormControl fullWidth>
            <InputLabel htmlFor="email">Email address</InputLabel>
            <Input
              id="email"
              type="email"
              aria-describedby="email-helper-text"
              onChange={onChange}
            />
          </FormControl>
        </div>
        <br />
        <div>
          <FormControl fullWidth>
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              id="password"
              type="password"
              aria-describedby="password-helper-text"
              onChange={onChange}
            />
          </FormControl>
        </div>
        <br />
        <div>
          <Button
            color="info"
            size="large"
            variant="contained"
            fullWidth
            type="submit"
            sx={{ textTransform: "none" }}
          >
            Submit
          </Button>
        </div>
      </form>
      <p>
        Don't have an account? <Link to="/sign-up"> Sign Up Here</Link>
      </p>
    </>
  );
}

export default SignInForm;
